import {
    createApiQueryHook,
    IApiQueryFunction,
    IOrderable,
    IPaginateable,
    mapOrder,
    mapPagination,
} from "../../utils/api";
import { serialize } from "../../utils/url";
import { ITagList } from "../types";

export interface ITagListQueryParameters extends IPaginateable, IOrderable<"title" | "createdAt" | "updatedAt"> {
    filters?: {
        title?: string | null;
    };
}

export type ITagListQueryResult = ITagList;

const mapFilters = (filters: ITagListQueryParameters["filters"]) => {
    const { title } = filters ?? {};

    return {
        title,
    };
};

export const tagListQuery: IApiQueryFunction<ITagListQueryParameters> = ({ pagination, order, filters }) => {
    return {
        method: "GET",
        url: `/tags${serialize(
            {
                ...mapPagination(pagination),
                ...mapOrder(order),
                ...mapFilters(filters),
            },
            true,
        )}`,
    };
};

export const useTagListQuery = createApiQueryHook<ITagListQueryParameters, ITagListQueryResult>(tagListQuery);
